import React, { useEffect, useRef, useState } from "react";
import { Badge, Dropdown, DropdownItem, Form } from "react-bootstrap";
import "./Navbar.css";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import {
  getChatsOpen,
  setCanSetActiveModels,
  setDefaultModelMode,
  setIsGenerateImage,
  setSelectedPersona,
  setShowNavMenu,
  setShowPlansModal,
  setShowSignPopup,
  toggleFullWidthMode,
} from "../../../../store/one-query/chatsSlice";
import {
  useArchievePersonaType,
  useGetConversationTypes,
} from "../../../../store/Apis/ConversationTypeApi";
import { conversationsActions } from "../../../../store/one-query/conversationSlice";
import {
  AppViewType,
  DefaultModelsNumber,
  ModeAccessibility,
  modelNames,
  PersonaItemData,
  PersonaType,
  ShareType,
  SubscriptionStatus,
} from "../../../../Helper";
import ModelSettings from "./ModelSettings";
import UpgradePlanButton from "./UpgradePlanButton";
import MenuIcon from "../../../../Custom-imeges/MenuIcon";
import OneChatOption from "../../../../Custom-imeges/OneChatOption";
import TwoChatsOption from "../../../../Custom-imeges/TwoChatsOption";
import FourChatsOption from "../../../../Custom-imeges/FourChatsOption";
import SixChatsOption from "../../../../Custom-imeges/SixChatsOption";
import ArrowUpIcon from "../../../../Custom-imeges/ArrowUpIcon";
import ArrowDown from "../../../../Custom-imeges/ArrowDown";
import SearchIcon from "../../../../Custom-imeges/SearchIcon";
import EditPinIcon from "../../../../Custom-imeges/EditPinIcon";
import TrashIcon from "../../../../Custom-imeges/TrashIcon";
import ModelSettingsIcon from "./ModelSettingsIcon";
import { useNavigate, useParams } from "react-router-dom";
import { updateSuccessPopupSavingState } from "../../../../store/one-query/modelsettings";
import { ClosedChatsModePopup } from "../Popups/ClosedChatsModePopup";
import PersonaModal from "./Persona/PersonaModal";
import UserProfile from "./UserProfile";
import {
  ConversationTypeRecord,
  conversationTypesActions,
} from "../../../../store/one-query/conversationType";
import ArchieveIcon from "../../../../Custom-imeges/ArchieveIcon";
import { useGetDefaultModelMode } from "../../../../store/Apis/ChatModelApi";
import { LockIcon } from "../../../../Custom-imeges/LockIcon";
import { Box, Typography, Tooltip } from "@mui/material";
import { StarsIcon } from "../../../../Custom-imeges/StarsIcon";
import { ImageGenerationSwitchAlert } from "../Alerts/ImageGenerationSwitchAlert";
import useNavigateToMainPage from "../../../../NavigateToMainPage";
import { SignInRegisterButtons } from "../../../../shared/SignIn&RegisterButtons";
import AvailablePackagesModal from "../../../CreditsScenario/AvailablePackagesModal";
import AddCredits from "../../../CreditsScenario/AddCredits";
import { SharePopup } from "../../../../shared/SharePopup";
import { ShareButton } from "../../../../shared/ShareButton";
import { useCreateShareUrl } from "../../../../store/Apis/ShareApi";

interface NavbarProps {
  setShowClosedChatsModeModal: (show: boolean) => void;
  showClosedChatsModeModal: boolean;
  currentAppView?: number;
  setCurrentAppView?: (view: number) => void;
}
const Navbar = (props: NavbarProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { workflowId } = useParams<{ workflowId: string }>();
  const [selectedPersonaItem, setSelectedPersonaItem] = useState<string | null>(
    ""
  );
  const lastActiveModels = useAppSelector(
    (s) => s.Conversations.lastActiveModels
  );
  const dropdownRef = useRef<HTMLDivElement>(null);
  const personaInputRef = useRef<HTMLInputElement>(null);
  const conversationTypes = useAppSelector((state) => state.ConversationTypes);
  const activeConversationId = useAppSelector(
    (state) => state.Conversations.activeConversationId
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showAddPersona, setShowAddPersona] = useState(false);
  const [personaItemDelete, setPersonaItemDelete] = useState<
    PersonaItemData | undefined
  >();
  const [personaModalType, setPersonaModalType] = useState("Create");
  const [search, setSearch] = useState("");
  const getConversationTypesMutate = useGetConversationTypes();
  const [updateCurrentPersona, setUpdateCurrentPersona] = useState({
    id: "",
    title: "",
    assistant: "",
    objective: "",
    createdAt: "",
  });
  const lastActiveModelsUpdated = useAppSelector(
    (state) => state.Conversations?.lastActiveModelsUpdatedFromBE
  );
  const [isHovered, setIsHovered] = useState(false);
  const [showModelSettings, setShowModelSettings] = useState<boolean>(false);
  const [showSwitchImageGenerationAlert, setShowSwitchImageGenerationAlert] =
    useState({
      show: false,
      mode: 0,
    });
  const [
    isAskForShowSwitchImageGenerationAlert,
    setIsAskForShowSwitchImageGenerationAlert,
  ] = useState(false);
  const [showAvailablePackages, setShowAvailablePackages] =
    useState<boolean>(false);
  const ChatsStore = useAppSelector((s) => s.ChatsState);
  const User = useAppSelector((s) => s.User);
  const [showClosedChatsModeModal, setShowClosedChatsModeModal] =
    useState(false);
  const { data: defaultModelModeRequestData, isSuccess: modelSettingsSuccess } =
    useGetDefaultModelMode();
  const navigateToMainPage = useNavigateToMainPage();
  const workflowSlice = useAppSelector((s) => s.workflows);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const { mutate: CreateShareUrl, data: sharingLinkData } = useCreateShareUrl();

  const archivePersona = useArchievePersonaType();
  const handleCloseUpgradeModal = () => {
    dispatch(setShowPlansModal(false));
  };

  const handleShowUpgradeModal = () => {
    setShowClosedChatsModeModal(false);
    dispatch(setShowPlansModal(true));
  };

  const handleClickOnModelSettings = () => {
    if (!props.showClosedChatsModeModal) {
      setShowModelSettings(true);
    }
  };

  const handleShowNavMenu = () => {
    dispatch(setShowNavMenu(!ChatsStore.showNavMenu));
  };

  const closeModelSettingsPopup = () => {
    setShowModelSettings(false);
  };

  const closeSwitchImageGenerationAlert = () => {
    setShowSwitchImageGenerationAlert({ show: false, mode: 0 });
  };

  useEffect(() => {
    getConversationTypesMutate();
  }, []);

  const closeFullWidthChat = () => {
    dispatch(toggleFullWidthMode(""));
  };

  const toggleDropdown = () => {
    if (!dropdownOpen) {
      setSearch(""); // Reset search when opening the dropdown
      if (personaInputRef.current) {
        personaInputRef.current.value = ""; // Clear the input field when opening
      }
    }

    if (!props.showClosedChatsModeModal) {
      setDropdownOpen(!dropdownOpen);
    }
  };

  // handel open model mode.
  const handleOpenModelMode = (mode: number) => {
    const modelMode = `Mode${mode}` as keyof typeof DefaultModelsNumber;
    dispatch(conversationsActions.setIsConHistoryClicked(false));
    let updatedOptions = ChatsStore.selectedOptions.slice(
      0,
      DefaultModelsNumber[modelMode]
    );
    const usedOptions = new Set(updatedOptions);
    for (let option of modelNames) {
      if (updatedOptions.length >= DefaultModelsNumber[modelMode]) break;
      if (!usedOptions.has(option)) {
        updatedOptions.push(option);
        usedOptions.add(option);
      }
    }
    dispatch(
      getChatsOpen({
        chatsNum: DefaultModelsNumber[modelMode],
        selectedOptions: updatedOptions,
      })
    );
    if (User.IsAuthenticated && ChatsStore.isGenerateImage && mode > 1) {
      dispatch(setIsGenerateImage(false));
    } else if (
      !User.IsAuthenticated &&
      ChatsStore.isGenerateImage &&
      mode > 0
    ) {
      dispatch(setIsGenerateImage(false));
    }
  };

  // handel selected chats number and witch model will open
  const handleColumnClick = (mode: number) => {
    if (!User.IsAuthenticated) {
      if (
        ChatsStore.isGenerateImage &&
        !isAskForShowSwitchImageGenerationAlert &&
        mode > 0
      ) {
        setShowSwitchImageGenerationAlert({ show: true, mode: mode });
      } else if (mode <= ModeAccessibility.Anonymous) {
        handleOpenModelMode(mode);
        props.setShowClosedChatsModeModal(false);
      } else {
        handleOpenModelMode(mode);
        props.setShowClosedChatsModeModal(true);
      }
    } else if (User.IsAuthenticated && !User.isSubscribed) {
      if (
        ChatsStore.isGenerateImage &&
        !isAskForShowSwitchImageGenerationAlert &&
        mode > 1
      ) {
        setShowSwitchImageGenerationAlert({ show: true, mode: mode });
      } else if (mode <= ModeAccessibility.Authenticated) {
        handleOpenModelMode(mode);
        props.setShowClosedChatsModeModal(false);
      } else {
        handleOpenModelMode(mode);
        props.setShowClosedChatsModeModal(true);
      }
    } else {
      if (
        ChatsStore.isGenerateImage &&
        !isAskForShowSwitchImageGenerationAlert &&
        mode > 1
      ) {
        setShowSwitchImageGenerationAlert({ show: true, mode: mode });
      } else {
        handleOpenModelMode(mode);
        props.setShowClosedChatsModeModal(false);
      }
    }
    if (
      window.location.href.includes("suites") ||
      window.location.href.includes("workflows")
    ) {
      navigateToMainPage();
    }
    closeFullWidthChat();
    dispatch(setCanSetActiveModels(true));
  };

  const handleSwitchImageGenerationLogic = () => {
    handleOpenModelMode(showSwitchImageGenerationAlert.mode);
    setShowSwitchImageGenerationAlert({ show: false, mode: 0 });
    dispatch(setIsGenerateImage(false));
  };

  const handleSetLastActiveModels = (
    chatsNum: number,
    updatedOptions: string[]
  ) => {
    dispatch(getChatsOpen({ chatsNum, selectedOptions: updatedOptions }));
  };

  // lastActiveModels
  useEffect(() => {
    if (lastActiveModels) {
      const lastActiveOptions: string[] = [];
      lastActiveModels?.forEach((model) => {
        if (model?.name?.toLowerCase() === "chatgpt") {
          lastActiveOptions.push("ChatGPT");
        } else if (model?.name?.toLowerCase() === "gemini") {
          lastActiveOptions.push("Gemini");
        } else if (model?.name?.toLowerCase() === "llama") {
          lastActiveOptions.push("Llama");
        }
        // else if (model.name?.toLowerCase() === "jinaai") {
        //   lastActiveOptions.push("JinAai");
        // }
        else if (model?.name?.toLowerCase() === "anthropic") {
          lastActiveOptions.push("Anthropic");
        } else if (model?.name?.toLowerCase() === "mistralai") {
          lastActiveOptions.push("MistralAi");
        } else if (model?.name?.toLowerCase() === "huggingface") {
          lastActiveOptions.push("HuggingFace");
        } else if (model?.name?.toLowerCase() === "nvidia") {
          lastActiveOptions.push("Nvidia");
        } else if (model?.name?.toLowerCase() === "alibaba") {
          lastActiveOptions.push("Alibaba");
        } else if (model?.name?.toLowerCase() === "microsoft") {
          lastActiveOptions.push("Microsoft");
        } else if (model?.name?.toLowerCase() === "deepseek") {
          lastActiveOptions.push("DeepSeek");
        }
      });
      if (lastActiveModels?.length > 0) {
        if (lastActiveModels.length === 1) {
          handleSetLastActiveModels(1, lastActiveOptions);
        }
        if (lastActiveModels.length === 2) {
          handleSetLastActiveModels(2, lastActiveOptions);
        } else if (lastActiveModels.length === 4) {
          handleSetLastActiveModels(4, lastActiveOptions);
        } else if (lastActiveModels.length === 6) {
          handleSetLastActiveModels(6, lastActiveOptions);
        }
      }
    }
  }, [lastActiveModelsUpdated]);

  const handleSelectCategory = (title: string) => {
    setSelectedPersonaItem(title);
    setDropdownOpen(false);
  };

  const deleteConversationType = (item: PersonaItemData) => {
    setPersonaModalType("Delete");
    setSelectedPersonaItem("Persona");
    setShowAddPersona(true);
    if (item) setPersonaItemDelete(item);
  };

  const handleOpenUpgradePlans = () => {
    dispatch(setShowPlansModal(true));
  };

  const openCreatePersonaModal = () => {
    setDropdownOpen(false);
    if (!User.IsAuthenticated) {
      dispatch(
        setShowSignPopup({
          show: true,
          type: "Create persona",
          message: "Exclusive Feature for Premium Users! ",
          btnTitle: "Sign In for Free",
          btnAction: "NavigateToLogin",
        })
      );
    } else if (User.IsAuthenticated && !User.isSubscribed) {
      dispatch(
        setShowSignPopup({
          show: true,
          type: "Create persona",
          message: "Exclusive Feature for Premium Users! ",
          btnTitle: "Go Premium",
          btnAction: "OpenUpgradePlans",
        })
      );
    } else if (User.IsAuthenticated && User.isSubscribed) {
      setPersonaModalType("Create");
      setShowAddPersona(true);
    }
  };

  const openUpdatePersonaModal = (item: any) => {
    if (item) {
      setDropdownOpen(false);
      // updateConversationType(item)
      setUpdateCurrentPersona(item);
      setPersonaModalType("Update");
      setShowAddPersona(true);
    }
  };

  const allConversations = useAppSelector(
    (state) => state?.Conversations.conversations
  );

  const selectedPersona = allConversations.find(
    (con) => con?.id === activeConversationId
  )?.persona;

  useEffect(() => {
    const personaExists = conversationTypes?.data?.some(
      (conversation) => conversation?.id === selectedPersona?.id
    );
    if (
      ChatsStore.selectedPersona.title &&
      ChatsStore.selectedPersona?.title?.length > 0
    ) {
      setSelectedPersonaItem(ChatsStore.selectedPersona?.title);
    } else if (selectedPersona?.title?.length > 0 && personaExists) {
      setSelectedPersonaItem(selectedPersona.title);
    } else {
      setSelectedPersonaItem("Persona");
    }
  }, [ChatsStore.selectedPersona, selectedPersona]);

  const setCurrentPersona = (persona: ConversationTypeRecord) => {
    if (
      User.IsAuthenticated ||
      (!User.IsAuthenticated && persona.allowAnonymous)
    ) {
      dispatch(setSelectedPersona(persona));
      handleSelectCategory(persona?.title);
    } else if (!User.IsAuthenticated && !persona.allowAnonymous) {
      dispatch(
        setShowSignPopup({
          show: true,
          type: "Persona",
          message: "To unlock this persona you need to Sign in.",
          btnTitle: "Sign In for Free",
          btnAction: "NavigateToLogin",
        })
      );
    }
  };

  let fullWidth =
    ChatsStore.fullWidthMode !== "" &&
    ChatsStore.fullWidthMode !== "ExpertHome";
  let isSelected = (columns: number) =>
    ChatsStore.chatsNum === columns &&
    ChatsStore.fullWidthMode !== "ExpertModel" &&
    ChatsStore.fullWidthMode !== "ExpertHome";

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  useEffect(() => {
    if (!showModelSettings) dispatch(updateSuccessPopupSavingState(false));
  }, [showModelSettings]);
  const handleArchievePersona = (persona: ConversationTypeRecord) => {
    if (persona?.id) {
      archivePersona(persona?.id);
    }
  };

  const handleOpenUpdatePersona = (item: any) => {
    openUpdatePersonaModal(item);
    setDropdownOpen(false);
  };
  useEffect(() => {
    // Get default model mode endpoint.
    if (defaultModelModeRequestData)
      dispatch(setDefaultModelMode(defaultModelModeRequestData));
  }, [defaultModelModeRequestData]);

  const handleBackFromSuiteHistoryToSuiteApp = () => {
    if (window.location.href.includes("history/text")) {
      navigate("suites/text-suite")
    } else if (window.location.href.includes("history/image")) {
      navigate("suites/image-suite")
    } else if (window.location.href.includes("history/video")) {
      navigate("suites/video-suite")
    }
  };

  const handleShowSharePopup = () => {
    const RequestData = {
      shareType: ShareType.Workflow,
      shareId: workflowSlice.currentWorkflowRunData.runId,
    };
    CreateShareUrl(RequestData);
    setShowSharePopup(true);
  };

  const handleCloseSharePopup = () => {
    setShowSharePopup(false);
  };
  const hideSelectModesAndPersona = window.location.href.includes("suites") ||
    window.location.href.includes("library");
  
  return (
    <>
      <div
        className={`expert-navbar ${window.location.href.includes("history") && "suite-history-screen"} ${fullWidth && "chat-full-width"} ${
          window.location.href.includes("suites")  &&
            !window.location.href.includes("history") || window?.location?.pathname.includes("/library") ? "suites-view" : ""
        } ${window.location.href.includes("workflows") && "workflows-navbar"}
          }`}
      >
        <div className="navbar_menu_logo">
          <div onClick={handleShowNavMenu}>
            <MenuIcon />
          </div>
          <img
            className={`expertex-logo ${ChatsStore.showNavMenu && "nav_logo"} `}
          />
        </div>

        {!hideSelectModesAndPersona && (
                  <div className={`nav-container ${window.location.href.includes("workflows") && "gap-0"}`}>
            <div
              className={` ${
                !User.IsAuthenticated && "landing-page"
              } d-flex gap-3 c-pointer`}
            >
              {!window.location.href.includes("workflows") && (
                <div className="shapes-container">
                  <div
                    className={`mode-one ${isSelected(1) && "selected"}`}
                    onClick={() => handleColumnClick(0)}
                  >
                    <OneChatOption />
                  </div>
                  <div
                    className={`mode-two ${isSelected(2) && "selected"}`}
                    onClick={() => handleColumnClick(1)}
                  >
                    <TwoChatsOption />
                  </div>
                  <div
                    className={`mode-four ${isSelected(4) && "selected"}`}
                    onClick={() => handleColumnClick(2)}
                  >
                    <FourChatsOption />
                  </div>
                  <div
                    className={`mode-six ${isSelected(6) && "selected"}`}
                    onClick={() => handleColumnClick(3)}
                  >
                    <SixChatsOption />
                  </div>
                </div>
              )}
            </div>

            {!window.location.href.includes("workflows") ? (
              <>
                <div
                  className={`selectCategory ${
                    !User.IsAuthenticated && "landing-page"
                  }`}
                >
                  <Dropdown
                    id="persona"
                    className="w-100"
                    autoClose="outside"
                    show={dropdownOpen}
                    ref={dropdownRef}
                  >
                    <Dropdown.Toggle className={`${dropdownOpen && "opened"}`}>
                      {dropdownOpen ? (
                        <div className="w-100 d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center w-100">
                            <label htmlFor="input" className="c-pointer">
                              <SearchIcon className="search-persona-icon" />
                            </label>
                            <Form.Control
                              ref={personaInputRef}
                              className="personaInput border-0 bg-transparent p-0 m-0 ms-2"
                              placeholder="Persona"
                              onChange={(e) => setSearch(e.target.value)}
                            />
                          </div>
                          <span onClick={toggleDropdown}>
                            <ArrowUpIcon className="persona-arrow" />
                          </span>
                        </div>
                      ) : (
                        <div
                          className={`persona-container ${
                            props.showClosedChatsModeModal && "not-allowed"
                          }`}
                          onClick={toggleDropdown}
                        >
                          <span className="selectedPersonaItem">
                            {selectedPersonaItem &&
                            selectedPersonaItem.length > 22
                              ? selectedPersonaItem.slice(0, 22) + "..."
                              : selectedPersonaItem}
                          </span>
                          <ArrowDown className="persona-arrow" />
                        </div>
                      )}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Box pr={0.5}>
                      <div id="category">
                        {conversationTypes &&
                          conversationTypes.data &&
                          conversationTypes.data
                            .filter((item) => {
                              return search !== ""
                                ? item.title
                                    ?.trim()
                                    .toLowerCase()
                                    .includes(search.trim().toLowerCase())
                                : !item.isArchived && item;
                            })
                            .map((item, i) => (
                              <DropdownItem
                                key={i}
                                className={`persona-item ${
                                  !item.allowAnonymous &&
                                  !User.IsAuthenticated &&
                                  "disabled-item"
                                } px-2 ${
                                  selectedPersonaItem === item.title
                                    ? "active"
                                    : ""
                                }`}
                              >
                                <div onClick={() => setCurrentPersona(item)}>
                                  <span
                                    className="persona-name"
                                  >
                                    {item.title}
                                  </span>
                                  {!User.IsAuthenticated &&
                                    !item.allowAnonymous && (
                                      <Badge className="bg-transparent">
                                        <LockIcon className="lock-persona-icon" />
                                      </Badge>
                                    )}
                                  {User.IsAuthenticated &&
                                    item.title !== "General" && (
                                      <>
                                        {item.personaType ===
                                          PersonaType.User && (
                                          <span
                                            onClick={(e) =>
                                              {
                                                e.stopPropagation();
                                                openUpdatePersonaModal(item)
                                              }
                                            }
                                          >
                                            <EditPinIcon className="edit-persona-icon" />
                                          </span>
                                        )}
                                      </>
                                    )}
                                  {User.IsAuthenticated && (
                                    <span
                                      onClick={(e) =>
                                        {
                                          e.stopPropagation();
                                          handleArchievePersona(item)
                                        }
                                      }
                                    >
                                      <ArchieveIcon className="edit-persona-icon" />
                                    </span>
                                  )}
                                </div>
                              </DropdownItem>
                            ))}
                      </div>
                      </Box>
                       <div
                        className="addPersona d-flex align-items-center gap-2 c-pointer"
                        onClick={openCreatePersonaModal}
                      >
                        <span id="category-name"> Create new persona </span>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>

                  <PersonaModal
                    show={showAddPersona}
                    personaItemDelete={personaItemDelete}
                    updateCurrentPersona={updateCurrentPersona}
                    personaModalType={personaModalType}
                    handleClose={() => setShowAddPersona(false)}
                    setSelectedPersonaItem={setSelectedPersonaItem}
                  />
                </div>
                <Tooltip
                  title="Model settings"
                  placement="right"
                  arrow
                  componentsProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "var(--A_background73)",
                        color: "var(--A_font-color48)",
                        padding: "0.3rem 0.8rem",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "var(--A_background73)",
                      },
                    },
                  }}
                >
                  <div
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={handleClickOnModelSettings}
                    className={`model-settings-icn ${
                      props.showClosedChatsModeModal && "not-allowed"
                    }`}
                  >
                    <ModelSettingsIcon />
                  </div>
                </Tooltip>
              </>
            ) : null}
            {workflowSlice.isWorkflowRunFinished &&
              workflowId &&
              workflowSlice.currentWorkflowRunData.runId ? (
              <Box onClick={handleShowSharePopup}>
                <ShareButton />
              </Box>
            ) : null}
          </div>
        )}
        {
          window.location.href.includes("suites/history") &&
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            gap: '8px',
            paddingLeft:'8px'
          }}>
              <Box>
              <img
                className="arrowIconImg"
                src="/Images/SettingsSideResources/icn-arrow-left.svg"
                onClick={handleBackFromSuiteHistoryToSuiteApp}
              />
              </Box>
              <Typography sx={{fontSize:"20px",fontWeight:"600"}}>History</Typography>
          </Box>
        }
        <div
          className="profile-help-container"
          style={{
            width: window.location.href.includes("suites") ? "100%" : "auto",
          }}
        >
          <AddCredits showAvailablePackages={showAvailablePackages} setShowAvailablePackages={setShowAvailablePackages}/>
          {/* Show how many days left to end free trial subscription */}
          {User.isSubscribed &&
            User.subscriptionStatus === SubscriptionStatus.Trial && (
              <Box
                sx={{
                  display: "flex",
                  gap: "8px",
                  "@media (max-width: 900px)": {
                    position: "absolute",
                    top: "0",
                    right: "5rem",
                  },
                }}
              >
                <StarsIcon className="freeTrialIcon" />
                <Typography sx={{ fontSize: "1.1rem" }}>
                  {User.endFreeTrialSubscriptionDate}
                </Typography>
              </Box>
            )}
          {User.IsAuthenticated && !User.isSubscribed && <UpgradePlanButton />}
          {User.IsAuthenticated ? <UserProfile /> : <SignInRegisterButtons />}
        </div>
      </div>
      {showModelSettings && modelSettingsSuccess && (
        <ModelSettings
          show={showModelSettings}
          handleClose={closeModelSettingsPopup}
        />
      )}
      {showSwitchImageGenerationAlert && ChatsStore.isGenerateImage && (
        <ImageGenerationSwitchAlert
          show={showSwitchImageGenerationAlert.show}
          handleClose={closeSwitchImageGenerationAlert}
          handleSwitch={handleSwitchImageGenerationLogic}
          isAskForShowSwitchImageGenerationAlert={
            isAskForShowSwitchImageGenerationAlert
          }
          setIsAskForShowSwitchImageGenerationAlert={
            setIsAskForShowSwitchImageGenerationAlert
          }
        />
      )}
      {showAvailablePackages && (
        <AvailablePackagesModal
          show={showAvailablePackages}
          handleClose={() => setShowAvailablePackages(false)}
        />
      )}
      {showSharePopup && (
        <SharePopup
          show={showSharePopup}
          handleClose={handleCloseSharePopup}
          sharingLink={sharingLinkData?.shareUrl || ""}
          title={`Sharing ${workflowSlice.selectedWorkflowData?.name || ""}`}
        />
      )}
    </>
  );
};

export default Navbar;
